// Login.jsx
import React, { useState } from "react";
import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { loginAction } from "../../store/actions/AuthActions";
import { verifyOtp } from "../../services/AuthService";
import logo from "../../assets/images/logo.png";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { loginConfirmedAction } from "../../store/actions/AuthActions";
import { saveTokenInLocalStorage } from "../../services/AuthService";
import Loader from "../components/Common/Loader";
import { showErrorAlert } from "../../services/ErrorHandlingService";

function Login(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [tempUser, setTempUser] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [resendTimer, setResendTimer] = useState(0);
  const [verifying, setVerifying] = useState(false);

  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [resendTimer]);

  const onLogin = async (e) => {
    e.preventDefault();
    setErrors({});

    let hasError = false;
    const errorObj = {};

    if (!username) {
      errorObj.username = "Username is required";
      hasError = true;
    }
    if (!password) {
      errorObj.password = "Password is required";
      hasError = true;
    }

    setErrors(errorObj);
    if (hasError) return;

    setLoading(true);

    try {
      const res = await dispatch(loginAction(username, password));

      if (res?.is2FA) {
        setIs2FAEnabled(true);
        setTempUser(res.data);

        setResendTimer(60); // 🔥 ADD THIS
      } else {
        // normal redirect
        const role = res?.data?.role_name;

        const roleRedirectMap = {
          Doctor: "/doctor",
          Receptionist: "/receptionist",
          Telecaller: "/telecaller",
          Admin: "/dashboard",
          Counsellor: "/counsellor",
          "Service Caller": "/service-caller",
          Medical: "/medical",
        };

        navigate(roleRedirectMap[role] || "/dashboard");
      }
    } catch (err) {
      console.error("Login failed:", err);
    } finally {
      setLoading(false);
    }
  };

  // console.log("VERIFY DATA:", tempUser);
  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join("");

    if (enteredOtp.length !== 6) {
      alert("Enter valid OTP");
      return;
    }

    try {
      setVerifying(true); // 🔥 START

      const adminId = tempUser?.admin_id;

      if (!adminId) {
        showErrorAlert("Invalid user session. Please login again.");
        return;
      }

      const res = await verifyOtp(Number(adminId), enteredOtp);

      if (res.data.status === "success") {
        const userData = tempUser;

        // ✅ NOW SAVE TOKEN HERE
        saveTokenInLocalStorage(userData);

        if (userData.token) {
          localStorage.setItem("token", userData.token);
        }

        dispatch(loginConfirmedAction(userData));

        navigate("/dashboard");

      } else {
        showErrorAlert(res.data.message || "Invalid OTP");
      }
    } catch (err) {
      console.error(err);
      showErrorAlert("OTP verification failed");
    } finally {
      setVerifying(false); // 🔥 STOP
    }
  };
  const handleOtpChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };


  const handleResendOtp = async () => {
    try {
      setLoading(true);

      const res = await dispatch(loginAction(username, password));

      if (res?.is2FA && res.data?.admin_id) {
        setTempUser(res.data);
        setResendTimer(60); // 🔥 ADD THIS
      }
    } catch (err) {
      console.error(err);
      showErrorAlert("Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };

  {
    loading && (
      <div className="text-center my-3">
        <Loader />
      </div>
    )
  }

  return (
    <div className="login-form-bx">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-md-7 box-skew d-flex">
            <div className="authincation-content">
              <Link to="#" className="login-logo">
                <img src={logo} alt="Logo" style={{ width: '150px', height: 'auto' }} />
              </Link>

              <div className="mb-4">
                <h3>Welcome to Rohati Ayurved</h3>
                <p>Sign in by entering information below</p>
              </div>

              {props.errorMessage && (
                <div className="alert alert-danger">{props.errorMessage}</div>
              )}

              <form onSubmit={onLogin}>
                <div className="form-group">
                  <label>       <strong className="">Email</strong>
                    <span className="required">*</span></label>
                  <input
                    type="text"
                    placeholder="Enter the Email"
                    className="form-control"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  {errors.username && (
                    <small className="text-danger">{errors.username}</small>
                  )}
                </div>

                <div className="form-group position-relative">
                  <label>
                    <strong>Password</strong> <span className="required">*</span>
                  </label>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter the Password"
                    className="form-control pr-5"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    className="position-absolute"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      right: "15px",
                      top: "45px",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                    title="Show password"
                  >
                    {showPassword ? <FiEye /> : <FiEyeOff />}
                  </span>
                  {errors.password && (
                    <small className="text-danger">{errors.password}</small>
                  )}
                </div>

                <div className="text-center mt-3">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block"
                    disabled={is2FAEnabled}
                  >
                    Sign In
                  </button>
                </div>

                {is2FAEnabled && (
                  <div className="mt-4 text-center">
                    <label className="mb-2"><strong>Enter OTP</strong></label>

                    <div className="d-flex justify-content-center gap-2">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          id={`otp-${index}`}
                          type="text"
                          maxLength="1"
                          className="form-control text-center"
                          value={digit}
                          onChange={(e) => handleOtpChange(e.target.value, index)}

                          onKeyDown={(e) => {
                            // allow only numbers + backspace
                            if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                              e.preventDefault();
                            }

                            // 🔥 BACKSPACE LOGIC
                            if (e.key === "Backspace") {
                              if (otp[index]) {
                                // current box madhe value aahe → clear it
                                const newOtp = [...otp];
                                newOtp[index] = "";
                                setOtp(newOtp);
                              } else if (index > 0) {
                                // current empty → go to previous
                                document.getElementById(`otp-${index - 1}`).focus();

                                const newOtp = [...otp];
                                newOtp[index - 1] = "";
                                setOtp(newOtp);
                              }
                            }
                          }}
                          onPaste={(e) => {
                            const paste = e.clipboardData.getData("text").trim();

                            if (!/^\d{6}$/.test(paste)) return;

                            const newOtp = paste.split("");
                            setOtp(newOtp);

                            document.getElementById("otp-5").focus();
                          }}
                        />
                      ))}
                    </div>

                    <div className="mt-3">
                      <button
                        type="button"
                        className="btn btn-success me-2"
                        onClick={handleVerifyOtp}
                        disabled={verifying}
                      >
                        {verifying ? "Verifying..." : "Verify OTP"}
                      </button>

                      <button
                        type="button"
                        className="btn btn-link"
                        onClick={handleResendOtp}
                        disabled={resendTimer > 0}
                      >
                        {resendTimer > 0
                          ? `Resend OTP in ${resendTimer}s`
                          : "Resend OTP"}
                      </button>
                    </div>
                  </div>
                )}
              </form>

              <div className="text-center mt-3">
                <Link to="/app-forget-password" className="text-primary">
                  Forgot Password?
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-5 d-flex box-skew1"></div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  errorMessage: state.auth.error,
});

export default connect(mapStateToProps)(Login);
